// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-list_App__DRX37 {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.player-list_Player__DI1Ow {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 250px;
    height: 50px;
    padding: 10px;

    border-radius: 6px;
    border: 1px solid blue;

    >div:nth-child(1) {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }
}

.player-list_country__ehS\\+P {
    width: 16px;
    height: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/ui/player-list.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,YAAY;IACZ,YAAY;IACZ,aAAa;;IAEb,kBAAkB;IAClB,sBAAsB;;IAEtB;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".App {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.Player {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    width: 250px;\n    height: 50px;\n    padding: 10px;\n\n    border-radius: 6px;\n    border: 1px solid blue;\n\n    >div:nth-child(1) {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 5px;\n    }\n}\n\n.country {\n    width: 16px;\n    height: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `player-list_App__DRX37`,
	"Player": `player-list_Player__DI1Ow`,
	"country": `player-list_country__ehS+P`
};
export default ___CSS_LOADER_EXPORT___;
